module.exports = __webpack_public_path__ + "static/media/Hosts@1x.62a3f176.png";